import { render, staticRenderFns } from "./InputDatePicker.vue?vue&type=template&id=0b6e8c7e"
import script from "./InputDatePicker.vue?vue&type=script&lang=js"
export * from "./InputDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports